import {DownloadPlatform, LocalDownloadInfo, Release, Season} from "../javaTypes";
import LocalDownload from "./LocalDownload";
import { createRoot } from "react-dom/client";

declare global {
    interface Window { season: Season, channelToken: string, channelName: string, downloadInfo: Record<DownloadPlatform, LocalDownloadInfo>, releases: Release[] }
}

const container = document.getElementById('reactContainer');
if (container) {
    const root = createRoot(container)
    root.render(<LocalDownload season={window.season} channelName={window.channelName} channelToken={window.channelToken} downloadInfo={window.downloadInfo} releases={window.releases} />);
} else {
    console.error("Container element not found")
}